import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { SchemaProvider } from '../../providers/SchemaProvider';
import { AutoField } from '../AutoField';
export const AnyOfField = ({ propName, anyOf }) => {
    return (_jsx(_Fragment, { children: anyOf === null || anyOf === void 0 ? void 0 : anyOf.map((schema, index) => {
            return (_jsx(SchemaProvider, { schema: schema, children: _jsx(AutoField, { propName: propName }) }, index));
        }) }));
};
//# sourceMappingURL=AnyOfField.js.map